import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {PagamentoEletronicoDialogComponent} from './pagamento-eletronico-dialog.component';

@NgModule({
  declarations: [PagamentoEletronicoDialogComponent],
  imports: [CommonModule, FormsModule, DialogModule],
  exports: [PagamentoEletronicoDialogComponent]
})
export class PagamentosEletronicosPedidoModule {}
